
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import VMware from './components/VMware';
import Solutions from './components/Solutions';
import Training from './components/Training';
import UseCases from './components/UseCases';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <VMware />
      <Solutions />
      <Training />
      <UseCases />
      <Testimonials />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
}
